import { api } from "../../helpers/api/handler"

export const unsubscribe = (token: string) =>
  api.post(`/auth/unsubscribe/${token}/`)
